import type { LocalizationResource } from '@clerk/express/types';
import { lookupLocaleKey } from '@plato/shared-util/locale';
import { getNavigatorLanguages } from '@plato/ui-legacy/lib/hooks/locale';
import { useMemo } from 'react';
import { de, en, fr } from '../i18n/clerk-localizations.ts';

const supportedClerkLocales = {
    de,
    en,
    fr,
};

export function useClerkLocalization(
    locale: string | string[] = getNavigatorLanguages(),
): LocalizationResource {
    return useMemo(
        () => lookupLocaleKey(supportedClerkLocales, locale) ?? supportedClerkLocales.de,
        [locale],
    );
}
